import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {BundleDownloaderComponent} from './bundle-downloader.component';

const routes: Routes = [{path: '', component: BundleDownloaderComponent}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class BundleDownloaderRoutingModule {
}
